const { default: server } = require("./server");

export const getAllApi = async (searchParams) => {
  const response = await server().get(`/webhookLogs/?${searchParams}`);

  return response.data;
};

export const getApi = async (id) => {
  const response = await server().get(`/webhookLogs/${id}`);

  return response.data;
};

export const editApi = async ({ data }) => {
  const response = await server().put("/webhookLogs", data);

  return response.data;
};

export const deleteApi = async (id) => {
  const response = await server().delete(`/webhookLogs/${id}`);

  return response.data;
};
